// axios
import axios from 'axios'
import { setupCache } from 'axios-cache-adapter'

// Create `axios-cache-adapter` instance
const cache = setupCache({
  maxAge: 5000
  
})

const baseURL = ""

export default axios.create({
  baseURL: baseURL,
  adapter: cache.adapter
  // You can add your headers here
})
